import { routes } from '@/routes/routes';
import {
  CartShoppingSolid,
  ChartLineSolid,
  CheckToSlotSolid,
  CircleNodesSolid,
  EnvelopeSolid,
  HouseSolid,
  MedalSolid,
  RightFromBracketSolid,
  StoreSolid,
  WalletSolid,
} from '@/assets/icons/iconComponents/navigation';

/**
 * @param {object} navBadges badge counts for nav items
 * @param {boolean} isNftEnabled when true, include NFTs sub-route under wallet
 * @returns {object[]} routing objects for the authenticated drawer
 */
export const authRoutes = (navBadges, isNftEnabled) => {
  const baseRoutes = [
    {
      ...routes.loggedInHome,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.loggedInHome.icon ? (
        routes.loggedInHome.icon
      ) : (
        <HouseSolid className="navIcon" />
      ),
    },
    {
      key: 'dashboard',
      value: 'Dashboard',
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.dashboard.icon ? (
        routes.dashboard.icon
      ) : (
        <ChartLineSolid className="navIcon" />
      ),
      subitems: [
        {
          ...routes.nodes,
          // Use icon from routes (respects brand customization) or fallback to default component
          icon: routes.nodes.icon ? (
            routes.nodes.icon
          ) : (
            <CircleNodesSolid className="navIcon" />
          ),
          badgeContent: navBadges.nodes,
        },
        {
          ...routes.rewards,
          // Use icon from routes (respects brand customization) or fallback to default component
          icon: routes.rewards.icon ? (
            routes.rewards.icon
          ) : (
            <MedalSolid className="navIcon" />
          ),
        },
        {
          ...routes.wallet,
          // Use icon from routes (respects brand customization) or fallback to default component
          icon: routes.wallet.icon ? (
            routes.wallet.icon
          ) : (
            <WalletSolid className="navIcon" />
          ),
          badgeContent: navBadges.wallet,
        },
        ...(isNftEnabled
          ? [
              {
                ...routes.nfts,
              },
            ]
          : []),
      ],
    },
    {
      ...routes.store,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.store.icon ? routes.store.icon : <StoreSolid className="navIcon" />,
    },
    {
      ...routes.cart,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.cart.icon ? (
        routes.cart.icon
      ) : (
        <CartShoppingSolid className="navIcon" />
      ),
      badgeContent: navBadges.cart,
    },
    {
      ...routes.dgf,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.dgf.icon ? routes.dgf.icon : <CheckToSlotSolid className="navIcon" />,
      badgeContent: navBadges.voting,
      subitems: [
        {
          ...routes.dgfVoting,
        },
        {
          ...routes.blockchainHealth,
        },
        {
          ...routes.blockchainSales,
        },
      ],
    },
    {
      ...routes.support,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.support.icon ? (
        routes.support.icon
      ) : (
        <EnvelopeSolid className="navIcon" />
      ),
    },
  ];

  return baseRoutes;
};

export const noAuthRoutes = [
  {
    ...routes.store,
    // Use icon from routes (respects brand customization) or fallback to default component
    icon: routes.store.icon ? routes.store.icon : <StoreSolid className="navIcon" />,
  },
  {
    ...routes.support,
    // Use icon from routes (respects brand customization) or fallback to default component
    icon: routes.support.icon ? (
      routes.support.icon
    ) : (
      <EnvelopeSolid className="navIcon" />
    ),
  },
];

export const accountRoutes = {
  manageAccount: { ...routes.manageAccountProfile },
  logout: { ...routes.logout, icon: <RightFromBracketSolid className="navIcon" /> },
};
